var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.679 6.47.998 1.061-4.967 5.277.026.027-.999 1.06-.025-.027-.025.027-.998-1.06.025-.027L3.748 7.53l.998-1.06 4.966 5.276 4.967-5.276Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgDown;